import LiveEventService from '../../services/LiveEventService'
import router from '../../router'

const state = () => ({
    liveEventLoading: false,
    liveEvent: null,
    liveEventError: null,
})

const mutations = {
    SET_LIVE_EVENT: (state, payload) => {
        state.liveEvent = payload;
    },
    SET_LIVE_EVENT_ERROR: (state, payload) => {
        state.liveEventError = payload;
    },
    SET_LOADING_LIVE_EVENT: (state, payload) => {
        state.liveEventLoading = payload
    },
}

const actions = {
    async fetchLiveEvent({commit}, webinarId){
        commit('SET_LOADING_LIVE_EVENT', true)
        commit('SET_LIVE_EVENT', null)
        commit('SET_LIVE_EVENT_ERROR', null)
        try{
            const response = await LiveEventService.getOne(webinarId);
            const link = response?.data?.link || null;
            commit('SET_LIVE_EVENT', link)
            return link;
        } catch (error) {
            const status = error?.response?.status;
            const data = error?.response?.data || {};

            if (status === 401) {
                if (data.message == "Sessão expirada") {
                    commit('SET_REDIRECT', router.currentRoute.value.path);
                }
                commit('LOG_USER_OUT');
            }

            const message = data.message
                || (error?.response ? 'Não foi possível gerar o link do evento ao vivo.' : 'Sem conexão com o servidor. Verifique sua internet e tente novamente.');

            commit('SET_LIVE_EVENT_ERROR', { status, code: data.code || null, message });
            commit('SET_ALERT', { heading: 'error', message });
            return null;
        } finally {
            commit('SET_LOADING_LIVE_EVENT', false)
        }
    },
}

const getters = {
    getLiveEvent: state => state.liveEvent,
    getLiveEventError: state => state.liveEventError,
    getLoadingLiveEvent: state => state.liveEventLoading,
}

export default {
    state,
    getters,
    mutations,
    actions
};